export const CONSTS = {
  PACKAGE: $localize`Package`,
  PALLET: $localize`Pallet`,
  MAX_DIMENSION: $localize`Max Dimension`,
  IN_UNIT: $localize`IN`,
  MIN_DIMENSION: $localize`Min Dimension`,
  MAX_WEIGHT: $localize`Max Weight`,
  MIN_WEIGHT: $localize`Min Weight`,
  LB_UNIT: $localize`lb`,
  MAX_GIRTH: $localize`Max Length & Girth Dimension`,
  MIN_GIRTH: $localize`Min Length & Girth Dimension`,
};
